/* eslint-disable no-console */
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { subscribe } from 'alfa';
import { Typography, message, Button, Icon, Popconfirm } from 'antd';
import { withTranslation } from 'react-i18next';

import ManagerList from './components/list';
import ManagerRepo from '../../repository/manager';
import Link from '../../components/link';

const { Title } = Typography;

const ManagerIndex = withTranslation()((props) => {
  const { business, t } = props;
  const [managers, setManagers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchManagers = useCallback(async () => {
    try {
      const { data: { managers: fetchedManagers } } = await ManagerRepo.fetchCollection(business);
      setManagers(fetchedManagers);
      setLoading(false);
    } catch (error) {
      message.error(t('error.loading_managers'));
      console.error('ERROR: ManagerIndex: ManagerRepo.fetchCollection()', error);
    } finally {
      setLoading(false);
    }
  }, [business, t]);

  useEffect(() => {
    fetchManagers();
  }, [fetchManagers]);

  const revoke = async (manager) => {
    setLoading(true);
    try {
      await ManagerRepo.delete(business, manager.id);
      fetchManagers();
      message.success(t('success.revoke_manager'));
    } catch (error) {
      console.error('ERROR: ManagerIndex: ManagerRepo.delete()', error);
      fetchManagers();
      message.error(t('error.revoke_manager'));
    }
  };

  const renderRevoke = (item) => (
    <Popconfirm title={t('manager.revoke_confirm')} placement="left" onConfirm={() => revoke(item)} okText={t('yes')} cancelText={t('no')}>
      <Button type="link">{t('revoke')}</Button>
    </Popconfirm>
  );

  return (
    <>
      <Title level={3}>
        {t('managers')}
        <Button.Group style={{ float: 'right' }}>
          <Link button to="/managers/new">
            <Icon type="plus" /> {t('create_manager')}
          </Link>
        </Button.Group>
      </Title>
      <ManagerList loading={loading} managers={managers.filter((manager) => !manager.disabled_at)} revoke={renderRevoke} />
    </>
  );
});

ManagerIndex.propTypes = {
  business: PropTypes.object,
  t: PropTypes.func,
};

export default subscribe(ManagerIndex, ['business']);
